import { useTranslation } from 'react-i18next';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import { REDUX_STORE_SLICES } from '../../../services/exports/Constants';
import useStore from '../../../hooks/store/useStore';
import useBasket from '../../../hooks/basket/useBasket';
import { Checkbox } from '../../ui/checkbox';
import Section from './Section';

export default function MarketingSubscriptionSection() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Marketing:MarketingSubscriptionConsent' });

  const { localData, update } = useOrderFlow();
  const { items } = useBasket();
  const { profile } = useStore<REDUX_STORE_SLICES.PROFILE>(REDUX_STORE_SLICES.PROFILE);

  return (
    <Section show={Boolean(profile?.id) && !profile?.is_marketing_subscriber && items.length > 0}>
      <div className="flex w-full items-start gap-xs cursor-pointer">
        <Checkbox
          checked={localData.marketing_consent ?? false}
          onCheckedChange={(checked) => update('marketing_consent', checked)}
          id="is_marketing_subscriber"
          className="my-auto"
        />
        <div className="cursor-pointer">
          <label
            htmlFor="is_marketing_subscriber"
            className="my-auto flex flex-col gap-1 cursor-pointer text-sm text-muted-foreground"
          >
            {t('title')}
          </label>
        </div>
      </div>
    </Section>
  );
}
